import get from 'lodash/get';

export const DataNames = {
  languages: 'languages',
  templates: 'templates',
  properties: 'properties',
  integratedProperties: 'integratedProperties',
  conferences: 'conferences',
};

const defaultLoadingData = {
  isLoading: true,
  data: null,
  error: null,
};

const defaultErrorData = {
  isLoading: false,
  data: null,
  error: true, // consider getting actual error strings in the future
};

const getDefaultComponentState = uuid => ({
  uuid,
  [DataNames.languages]: { ...defaultLoadingData },
  [DataNames.templates]: { ...defaultLoadingData },
  [DataNames.properties]: { ...defaultLoadingData },
  [DataNames.integratedProperties]: { ...defaultLoadingData },
  [DataNames.conferences]: { ...defaultLoadingData },
});

export const defaultState = {
  dataByComponentUuid: {},
};

const getUpdatedData = (state, uuid, dataName, data) => {
  const { dataByComponentUuid } = state;
  const componentData = get(
    dataByComponentUuid,
    uuid,
    getDefaultComponentState(uuid),
  );
  componentData[DataNames[dataName]] = data;

  return {
    ...state,
    dataByComponentUuid: {
      ...dataByComponentUuid,
      [uuid]: componentData,
    },
  };
};

export default function formMessagesEditor(state = defaultState, action) {
  switch (action.type) {
    case 'LOAD_EMAIL_MESSAGE_EDITOR_DATA_PENDING': {
      const { uuid, dataName } = action.payload;
      return getUpdatedData(state, uuid, dataName, { ...defaultLoadingData });
    }
    case 'LOAD_EMAIL_MESSAGE_EDITOR_DATA_SUCCESS': {
      const { uuid, data, dataName } = action.payload;
      return getUpdatedData(state, uuid, dataName, data);
    }
    case 'LOAD_EMAIL_MESSAGE_EDITOR_DATA_ERROR': {
      const { uuid, dataName } = action.payload;
      return getUpdatedData(state, uuid, dataName, { ...defaultErrorData });
    }
    default:
      return state;
  }
}
